import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CandidateComponent } from './candidate.component';
import { CandidateRoutingModule } from './candidate-routing.module';

// Account
import { AccountCandidateEditComponent } from './components/account-candidate-edit/account-candidate-edit.component';

// Curriculum
import { CandidateHvComponent } from './components/candidate-hv/candidate-hv.component';

// Vacancies
import { CandidateVacanciesComponent } from './components/candidate-vacancies/candidate-vacancies.component';

// Applications
import { CandidateApplicationsComponent } from './components/candidate-applications/candidate-applications.component';


import { AttachCandidateDocumentationComponent } from './components/attach-candidate-documentation/attach-candidate-documentation.component';
import { CandidateFamiliarStructureComponent } from './components/candidate-familiar-structure/candidate-familiar-structure.component';
import { CandidateEmergencyContactComponent } from './components/candidate-emergency-contact/candidate-emergency-contact.component';

import { CandidateWorkExperiencesComponent } from './components/candidate-work-experiences/candidate-work-experiences.component';

import { LanguageModule } from '../language/language.module';

import { PagesModule } from '../employee/pages/pages.module';

import { NgaModule } from '../../theme/nga.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { DndModule } from 'ng2-dnd';
import { DisabilityModule } from '../disability/disability.module';

import {
  ButtonModule,
  SplitButtonModule,
  GrowlModule,
  MessagesModule,
  InputTextModule,
  PasswordModule,
  SlideMenuModule,
  FileUploadModule,
  DataTableModule,
  SharedModule,
  InputTextareaModule,
  DropdownModule,
  ChipsModule,
  DialogModule,
  RatingModule,
  ConfirmDialogModule,
  ConfirmationService,
  InputMaskModule,
  GMapModule,
  CheckboxModule,
  MultiSelectModule,
  AutoCompleteModule,
  SelectButtonModule,
  InputSwitchModule,
  ChartModule,
  ToggleButtonModule,
  AccordionModule,
  PanelModule,
  FieldsetModule,
  CalendarModule,
  TabViewModule,
  StepsModule,
  LightboxModule,
  TooltipModule,
  EditorModule,
  RadioButtonModule,
  ProgressBarModule,
} from 'primeng/primeng';

import { SidebarModule } from 'primeng/components/sidebar/sidebar';
import {ScheduleModule} from 'primeng/components/schedule/schedule';

import { NgxChartsModule } from '@swimlane/ngx-charts';

import { StoreModule } from '@ngrx/store';

import { Angular2PromiseButtonModule } from 'angular2-promise-buttons/dist';

import { AgmCoreModule } from '@agm/core';

import { HttpModule, Http, RequestOptions } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ApplicationPipesModuleModule } from '../application-pipes-module/application-pipes-module.module';



export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, '/assets/i18n/', '.po');
}

@NgModule({
  imports: [
    CommonModule,
    CandidateRoutingModule,
    LanguageModule,
    PagesModule,
    DisabilityModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    SplitButtonModule,
    GrowlModule,
    MessagesModule,
    InputTextModule,
    PasswordModule,
    SlideMenuModule,
    FileUploadModule,
    DataTableModule,
    SharedModule,
    InputTextareaModule,
    DropdownModule,
    ChipsModule,
    DialogModule,
    RatingModule,
    ConfirmDialogModule,
    InputMaskModule,
    GMapModule,
    CheckboxModule,
    MultiSelectModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputSwitchModule,
    ChartModule,
    ToggleButtonModule,
    AccordionModule,
    PanelModule,
    CalendarModule,
    TabViewModule,
    StepsModule,
    LightboxModule,
    TooltipModule,
    EditorModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ScheduleModule,
    ProgressBarModule,
    Angular2PromiseButtonModule.forRoot({
        spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
        disableBtn: true,
        btnLoadingClass: 'is-loading',
        handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD041mK0SKDmCT9s6gaZ3XAq-psuHgA_Ec',
      libraries: ['places']
    }),
    StoreModule.forRoot({
    }),
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    DndModule,
    ApplicationPipesModuleModule
  ],
  exports: [ ],  
  declarations: [
    CandidateComponent,
    CandidateHvComponent,
    CandidateVacanciesComponent,
    CandidateApplicationsComponent,
    AccountCandidateEditComponent,
    AttachCandidateDocumentationComponent,
    CandidateFamiliarStructureComponent,
    CandidateEmergencyContactComponent,
    CandidateWorkExperiencesComponent,
    // CandidateDisabilitiesComponent,
    // NewCandidateDisabilitieComponent,
    // DocumentsUploadTypedisabilitiesComponent,
  ]
})
export class CandidateModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/candidate.module.ts